import { Route } from '@angular/router';
import { LoginGuard, PermissionGuard } from '@simac/ui';

export const OutboundMovePalletRoute: Route = {
  path: 'outbound/update',
  children: [
    {
      path: '',
      loadComponent: () => import('./pages/move-pallet.component').then((m) => m.OutboundMovePalletComponent),
    },
  ],
  canActivate: [LoginGuard, PermissionGuard],
};
